import Tab from "components/Tab";
import WebSurveys from "../../../../contents/docs/surveys/_snippets/web-surveys-installation.mdx";
import ReactNativeSurveys from "../../../../contents/docs/surveys/_snippets/react-native-surveys-installation.mdx";
import IOSSurveys from "../../../../contents/docs/surveys/_snippets/ios-surveys-installation.mdx";
import FlutterSurveys from "../../../../contents/docs/surveys/_snippets/flutter-surveys-installation.mdx";
import * as React from 'react';
export default {
  Tab,
  WebSurveys,
  ReactNativeSurveys,
  IOSSurveys,
  FlutterSurveys,
  React
};